/**
 * Test validation utilities for admin test creation.
 *
 * Scheduling model:
 *  - release_date : exact date the test becomes available (YYYY-MM-DD)
 *  - release_month: calendar month 1-12 (category the test is listed under)
 *  - release_order: positive integer, DISPLAY/SORT ORDER ONLY.
 *                   Does NOT determine release_month or release_date.
 *
 * School year mapping:
 *  - Months 9-12 (Sep-Dec) -> first  year of school_year
 *  - Months  1-8 (Jan-Aug) -> second year of school_year
 */

export function getExpectedYearForReleaseMonth(schoolYear, releaseMonth) {
  if (!schoolYear) return null
  const [startYear, endYear] = schoolYear.split('/').map(Number)
  const m = Number(releaseMonth)
  if (!Number.isInteger(m) || m < 1 || m > 12) return startYear
  return m >= 9 && m <= 12 ? startYear : endYear
}

export function getMonthNameSk(releaseMonth) {
  const mapping = {
    1: 'Január',
    2: 'Február',
    3: 'Marec',
    4: 'Apríl',
    5: 'Máj',
    6: 'Jún',
    7: 'Júl',
    8: 'August',
    9: 'September',
    10: 'Október',
    11: 'November',
    12: 'December',
  }
  return mapping[Number(releaseMonth)] || 'Neznámy'
}

export function getSuggestedReleaseDate(schoolYear, releaseMonth) {
  if (!schoolYear || !releaseMonth) return null
  const year = getExpectedYearForReleaseMonth(schoolYear, releaseMonth)
  const m = Number(releaseMonth)
  if (!year || !Number.isInteger(m) || m < 1 || m > 12) return null
  return `${year}-${String(m).padStart(2, '0')}-01`
}

export function validateReleaseDateConsistency(schoolYear, releaseMonth, releaseDate) {
  if (!releaseDate || !schoolYear || !releaseMonth) {
    return { valid: true }
  }

  const expectedYear = getExpectedYearForReleaseMonth(schoolYear, releaseMonth)
  const expectedMonth = Number(releaseMonth)
  const [dateYear, dateMonth] = releaseDate.split('-').map(Number)

  const isValid = dateYear === expectedYear && dateMonth === expectedMonth

  return {
    valid: isValid,
    expectedYear,
    expectedMonth,
    actualYear: dateYear,
    actualMonth: dateMonth,
    message: isValid
      ? null
      : `Dátum vydania musí byť v mesiaci ${getMonthNameSk(expectedMonth)} ${expectedYear} (zvolený mesiac a školský rok).`,
  }
}

/**
 * Calendar months in Slovak school-year chronological order:
 * September first, then Oct..Dec, Jan..Aug.
 */
export const SCHOOL_YEAR_MONTHS = [
  { value: 9, label: 'September' },
  { value: 10, label: 'Október' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
  { value: 1, label: 'Január' },
  { value: 2, label: 'Február' },
  { value: 3, label: 'Marec' },
  { value: 4, label: 'Apríl' },
  { value: 5, label: 'Máj' },
  { value: 6, label: 'Jún' },
  { value: 7, label: 'Júl' },
  { value: 8, label: 'August' },
]
